import { RgShallowClone } from "@project-rouge/rg-three";
import { MathUtils } from "three";
import { BP2D } from "binpackingjs";
const BinPackFlats = ({ space, flats, flatsCount, totalCores }) => {
	const bins = [];
	const boxes = createBoxes(flats, flatsCount);
	const ascBoxes = boxes.slice().sort((a, b) => a.width - b.width);
	const desBoxes = ascBoxes.slice().reverse();
	let remainingSpace = space;
	for (let lgI = 0; lgI < 2; lgI++) {
		const nextSmFlat = (desBoxes[lgI] || desBoxes[0]).width;
		if (remainingSpace >= nextSmFlat) {
			const width = MathUtils.clamp(remainingSpace, ascBoxes[0].width, nextSmFlat);
			const bin = new BP2D.Bin(width, 1);
			bins.push(bin);
			remainingSpace -= width;
		}
	}
	const smI = 0;
	if (totalCores > 1) {
		totalCores--;
		const width = remainingSpace / totalCores;
		const nextSmFlat = (ascBoxes[smI] || ascBoxes[0]).width;
		while (remainingSpace >= nextSmFlat) {
			const bin = new BP2D.Bin(width, 1);
			bins.splice(1, 0, bin);
			remainingSpace -= width;
			totalCores--;
		}
		if (totalCores === 1) {
			const width$1 = nextSmFlat;
			const prevBinWidth = bins[bins.length - 1].width - (width$1 - remainingSpace);
			bins[bins.length - 1] = new BP2D.Bin(prevBinWidth, 1);
			const bin = new BP2D.Bin(width$1, 1);
			bins.push(bin);
			totalCores--;
		}
	}
	new BP2D.Packer(bins).pack(boxes);
	if (boxes.filter((b) => !b.packed).length) throw new Error("Agg4Errors: BinPackRemaining");
	return bins.map((b) => b.boxes.map((box) => RgShallowClone(box.data)));
};
var createBoxes = (flats, combs) => {
	const boxes = [];
	for (let x = 0; x < flats.length; x++) {
		const flat = flats[x];
		for (let y = 0; y < combs[x]; y++) {
			const box = new BP2D.Box(flat.size[0], 1, true);
			box.data = flat;
			boxes.push(box);
		}
	}
	return boxes;
};
export { BinPackFlats };

//# sourceMappingURL=index190.js.map